import React from 'react'
import useGetData from 'hooks/useGetData'
import { FormattedMessage } from 'react-intl'
import {
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap'

const ARGS = { limit: 10000, isTemplate: true } // TODO: Convert to infinite loader

export default function TemplateField (field) {
  const {
    data,
  } = useGetData('HomeLayouts', ARGS)

  return data && data.Layouts.length > 0 ? (
    <React.Fragment>
      <FormGroup>
        <ControlLabel><FormattedMessage id='DESK_TEMPLATE' /></ControlLabel>
        <FormControl
          {...field.input}
          componentClass='select'
        >
          <FormattedMessage id='DESK_TEMPLATE_SELECT_NONE'>
            {(formattedMessage) => (
              <option value='empty'>{formattedMessage}</option>
            )}
          </FormattedMessage>
          {data.Layouts
            .filter(Layout => !Layout.IsLocked)
            .map(Layout =>
              <option
                key={Layout.Id}
                value={Layout.Id}
              >
                {Layout.Name}
              </option>
            )
          }
        </FormControl>
      </FormGroup>
    </React.Fragment>
  ) : null
}
